import React from 'react';
import styled from 'styled-components';

const Fill = styled.div`
  flex-grow: 1;
  flex-shrink: 0;
`;

export default Fill;
